module.exports = __webpack_public_path__ + "img/imagen3.c00cf43b.png";